import { Injectable } from '@angular/core';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment} from 'moment';

const moment = _rollupMoment || _moment;

@Injectable()
export class CustomDateService {

  constructor() { }

  public get momentToday() : moment.Moment {
    return moment();
  }

  getDateFromMoment(value : moment.Moment): Date {
    let dateYear: string = value.format('YYYY');
    let dateDay: string = value.format('DD');
    let dateMonth: string = value.format('MM');

    return new Date(dateYear + '-' + dateMonth + '-' + dateDay);
  }

  getMomentFromDate(value: Date): moment.Moment {
    return moment(value);
  }
}
